import './App.css';
import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './User-Component/Navbar';
import UserLogin from './User-Component/userlogin';
import Register from './User-Component/register';
import AdminLogin from './Admin-Component/adminlogin';
import WhatsAppAuth from './WhatsAppAuth'; 
import About from './About';
import Contact from './Contact'; 
import Profile from './User-Component/profile';
import AdminUsers from './Admin-Component/AdminUsers';

import AdminDashboard from './Admin-Component/admindashboard';
import AdminSidebar from './Admin-Component/AdminSidebar';
// import AdminRequest from './Admin-Component/adminrequest';

// Keeps the browser's address bar always showing "/Goyee", regardless of
// which page is actually being rendered underneath. This only rewrites
// what's displayed in the URL bar via history.replaceState — it does NOT
// go through React Router's own navigation, so React Router's internal
// location state (what every page/component actually reads to know which
// route it's on) is completely unaffected. All existing routing, active-
// link highlighting, admin-page checks, and the Messages panel logic
// keep working exactly as before.
//
// Trade-off (agreed): since the address bar no longer reflects the real
// page, refreshing, using the browser's back/forward buttons, or
// bookmarking will not reliably return you to the specific page you were
// on — the app will fall back to the Home page in that case (see the
// catch-all Route below).
function UrlMask() {
  const location = useLocation();

  useEffect(() => {
   if (window.location.pathname !== "/whatsapp-bulk-message-sender") {
  window.history.replaceState(
    window.history.state,
    "",
    "/whatsapp-bulk-message-sender" +
      window.location.search +
      window.location.hash
  );
}
  }, [location]);

  return null;
}

function LayoutManager() {
  const location = useLocation();
  const isAdminPage = location.pathname.includes("goyee-admin") && !location.pathname.includes("login");
  const isLoginPage = location.pathname.includes("goyee-admin-login");

  if (isLoginPage) return null;
  if (isAdminPage) return <AdminSidebar />;
  return <Navbar />;
}

function App() {
  return (
    <BrowserRouter>
      <div>
        <LayoutManager />
        <UrlMask />
        <Routes>
          <Route path="/" element={<WhatsAppAuth />} />
          
          <Route path="/userloginpage" element={<UserLogin />} />
          <Route path="/register" element={<Register />} />
          <Route path="/goyee-admin-login" element={<AdminLogin />} />
          <Route path="/goyee-admin-dashboard" element={<AdminDashboard />} />
          <Route path="/goyee-admin-users" element={<AdminUsers />} />
          {/* <Route path="/adminrequest" element={<AdminRequest />} /> */}
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/profile" element={<Profile />} />

          {/* Fallback: since the address bar always shows "/Goyee" (see
              UrlMask above) and there's no dedicated route for that exact
              path, refreshing the page would otherwise render nothing.
              This sends a refresh to Home instead of a blank screen. */}
          <Route path="*" element={<WhatsAppAuth />} />

        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;